import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import DashboardIcon from '@material-ui/icons/Dashboard';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import PhotoLibraryIcon from '@material-ui/icons/PhotoLibrary';
import { BsPersonFillGear } from 'react-icons/bs';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import PeopleIcon from '@mui/icons-material/People';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import PriceChangeIcon from '@mui/icons-material/PriceChange';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import NotificationsIcon from '@mui/icons-material/Notifications';
import iconPng from 'assets/icons/logo.svg';
import DescriptionIcon from '@mui/icons-material/Description';
import { Print } from '@material-ui/icons';
import { BarChart, PaymentOutlined } from '@mui/icons-material';

const getHeaderData = (t) => ({
  icon: iconPng,
  siteName: 'Qdak photo portal',
  options: {
    admin: [
      {
        name: t('headerData.orders'),
        icon: <ShoppingCartIcon style={{ color: 'whitesmoke' }} />,
        to: 'orders',
        divider: false,
        disabled: false
      },
      {
        name: t('headerData.reports'),
        icon: <BarChart style={{ color: 'whitesmoke' }} />,
        to: 'reports',
        divider: false,
        disabled: false
      },
      {
        name: t('headerData.printing'),
        icon: <Print style={{ color: 'whitesmoke' }} />,
        to: 'printing',
        divider: false,
        disabled: false
      },
      {
        name: t('headerData.templates'),
        icon: <PriceChangeIcon style={{ color: 'whitesmoke' }} />,
        to: 'templates',
        divider: false,
        disabled: false
      },
      {
        name: t('headerData.galleries'),
        icon: <PhotoLibraryIcon style={{ color: 'whitesmoke' }} />,
        to: 'galleries',
        divider: false,
        disabled: false
      },
      {
        name: t('headerData.roles'),
        icon: <PeopleIcon style={{ color: 'whitesmoke' }} />,
        to: 'roles',
        divider: false,
        disabled: false
      },
      {
        name: t('headerData.invoicing'),
        icon: <ReceiptLongIcon style={{ color: 'whitesmoke' }} />,
        to: 'invoicing',
        divider: false,
        disabled: false
      },
      {
        name: t('headerData.documents'),
        icon: <DescriptionIcon style={{ color: 'whitesmoke' }} />,
        to: 'documents',
        divider: false,
        disabled: false
      },
      {
        name: t('headerData.subscriptions'),
        icon: <DescriptionIcon style={{ color: 'whitesmoke' }} />,
        to: 'subscriptions',
        divider: false,
        disabled: false
      }
      /*
     NEEDED IN PHOTOGRAPHER PROFILE VERSION
     {
        name: 'Fotós profil',
        icon: <ImProfile style={{ color: 'whitesmoke' }} size={23} />,
        to: 'photographer-profile',
        divider: true,
        disabled: false
      },*/
    ],
    superAdmin: [
      {
        name: t('headerData.dashboard'),
        icon: <DashboardIcon style={{ color: 'whitesmoke' }} />,
        to: 'dashboard',
        divider: false,
        disabled: false
      },
      {
        name: t('headerData.payments'),
        icon: <PaymentOutlined style={{ color: 'whitesmoke' }} />,
        to: 'payments',
        divider: false,
        disabled: false
      },
      {
        name: t('headerData.pricing'),
        icon: <PriceChangeIcon style={{ color: 'whitesmoke' }} />,
        to: 'pricing',
        divider: false,
        disabled: false
      },
      {
        name: t('headerData.users'),
        icon: <PeopleAltIcon style={{ color: 'whitesmoke' }} />,
        to: 'users',
        divider: false,
        disabled: false
      },
      {
        name: t('headerData.notifications'),
        icon: <NotificationsIcon style={{ color: 'whitesmoke' }} />,
        to: 'notifications',
        divider: false,
        disabled: false
      },
      {
        name: t('headerData.blogs'),
        icon: <MenuBookIcon style={{ color: 'whitesmoke' }} />,
        to: 'blogs',
        divider: false,
        disabled: false
      }
    ],
    printerAdmin: {
      name: t('headerData.printing'),
      icon: <Print style={{ color: 'whitesmoke' }} />,
      to: 'printer',
      divider: false,
      disabled: false
    },
    site: [
      {
        name: t('headerData.roles'),
        icon: <PeopleIcon style={{ color: 'whitesmoke' }} />,
        to: 'roles',
        divider: false,
        disabled: false
      },
      {
        name: t('headerData.invoicing'),
        icon: <ReceiptLongIcon style={{ color: 'whitesmoke' }} />,
        to: 'invoicing',
        divider: false,
        disabled: false
      },
      {
        name: t('headerData.documents'),
        icon: <DescriptionIcon style={{ color: 'whitesmoke' }} />,
        to: 'documents',
        divider: false,
        disabled: false
      }
    ],
    profile: [
      {
        name: t('headerData.profile'),
        icon: <BsPersonFillGear size={23} style={{ color: 'whitesmoke' }} />,
        to: 'profile',
        divider: false,
        disabled: false
      }
    ]
  },
  logoutOption: {
    name: t('common.logout'),
    to: '/',
    icon: <ExitToAppIcon size={25} style={{ color: 'whitesmoke' }} />,
    onClick: (logoutFn) => {
      logoutFn();
      return false;
    },
    divider: false,
    disabled: false
  }
});

export default getHeaderData;
